import { flattenColorPalette } from "../flatten-color-palette";
import { cliColors } from "./colors";

/**
 * BismillahCSS Shared Utilities
 * Optimized for low overhead and maximal design intelligence.
 */
export const bUtils = {
    flattenColorPalette,
    cliColors,

    /**
     * Generates a unique component ID for runtime tracking.
     */
    generateID: (prefix = 'b-') => `${prefix}${Math.random().toString(36).substring(2, 9)}`,

    /**
     * Helper to merge styles with framework defaults.
     */
    mergeStyles: (base: string, override: string) => {
        return `${base} ${override}`.trim();
    }
};

export default bUtils;
export { flattenColorPalette };
